import type { FieldError } from 'react-hook-form'

export const requiredError: FieldError = {
  type: 'required',
  message: 'This field is required',
}
